(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["collection-intro"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kv-collection-intro')) {
    class KvCollectionIntro extends HTMLElement {
      connectedCallback() {
        this.text = this.querySelector('.kv-intro__text');
        this.toggle = this.querySelector('.kv-intro__toggle');
        if (!this.text || !this.toggle) return;
        this.toggle.addEventListener('click', () => this.setExpanded(!this.hasAttribute('expanded')));
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.text);
        this.update();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      setExpanded(expanded) {
        this.toggleAttribute('expanded', expanded);
        this.toggle.setAttribute('aria-expanded', String(expanded));
      }

      update() {
        if (this.hasAttribute('expanded')) return;
        this.toggle.hidden = this.text.scrollHeight <= this.text.clientHeight + 1;
      }
    }

    customElements.define('kv-collection-intro', KvCollectionIntro);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["kavacha-review-link"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.kavachaReviewLink) return;
    window.kavachaReviewLink = true;

    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (!(event.target instanceof Element)) return;

      const link = event.target.closest('a[data-kavacha-review-link]');
      if (!link || !link.hash) return;

      const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
      if (!target) return;

      event.preventDefault();
      // 'instant', not 'auto': the page sets scroll-behavior: smooth.
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      target.scrollIntoView({ behavior, block: 'start' });
      target.focus({ preventScroll: true });

      // The sticky header can shrink on the way down, so its height (the heading's scroll
      // margin) is smaller at the landing than at the start. Check shortly after the scroll ends,
      // once the header has settled, and again later for browsers without scrollend.
      let checks = 0;
      const settle = () => {
        if (checks++ > 1) return;
        const margin = parseFloat(getComputedStyle(target).scrollMarginBlockStart) || 0;
        if (Math.abs(target.getBoundingClientRect().top - margin) > 4) {
          target.scrollIntoView({ behavior, block: 'start' });
        }
      };
      window.addEventListener('scrollend', () => setTimeout(settle, 300), { capture: true, once: true });
      setTimeout(settle, 1500);
      history.replaceState(history.state, '', link.hash);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-facts"] && !Shopify.designMode) return;
  try {
    document.addEventListener('shopify:product:select', (event) => {
    const source = event.target;
    if (!(source instanceof Element) || source.closest('product-card, dialog')) return;
    if (!event.promise) return;

    event.promise
      .then((result) => {
        const detail = result && result.detail;
        const html = detail && detail.html;
        if (!html) return;

        // A facts block whose section rendered nothing on the first load (for example a
        // pending-only Facts block as the only child of Product story) has no element to update.
        // Its section wrapper still exists, empty, so mount the fetched section into it.
        html.querySelectorAll('[data-kv-facts]').forEach((next) => {
          if (!(next instanceof HTMLElement)) return;
          if (detail.productId && String(detail.productId) !== next.dataset.productId) return;
          if (document.querySelector(`[data-kv-facts="${next.dataset.kvFacts}"]`)) return;
          const fetchedSection = next.closest('.shopify-section');
          if (!fetchedSection || !fetchedSection.id) return;
          const mount = document.getElementById(fetchedSection.id);
          if (mount instanceof HTMLElement && mount.innerHTML.trim() === '') {
            mount.innerHTML = fetchedSection.innerHTML;
          }
        });

        document.querySelectorAll('[data-kv-facts]').forEach((facts) => {
          if (!(facts instanceof HTMLElement)) return;
          if (detail.productId && String(detail.productId) !== facts.dataset.productId) return;

          const next = html.querySelector(`[data-kv-facts="${facts.dataset.kvFacts}"]`);
          if (next instanceof HTMLElement) {
            facts.innerHTML = next.innerHTML;
            facts.hidden = next.hidden;
          } else {
            facts.replaceChildren();
            facts.hidden = true;
          }
        });
      })
      .catch(() => {});
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-fulfillment"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('[data-kv-open-target]') : null;
    if (!link) return;
    const target = document.getElementById(link.getAttribute('data-kv-open-target'));
    if (!target) return;
    event.preventDefault();
    const details = target.closest('details');
    if (details && !details.open) {
      details.querySelector('summary')?.click();
      if (!details.open) details.open = true;
    }
    const scrollTarget = details || target;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    scrollTarget.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    const summary = details ? details.querySelector('summary') : null;
    (summary || target).focus({ preventScroll: true });
  });
  } catch(e) { console.error(e); }
})();

})();
